import React from 'react';
import { TransactionOutlined, OrderedListOutlined } from '@ant-design/icons';
import can from '../../components/ability';
import AppIconGroup from '../../components/app-icon-group';
import ProxyList from './list';
import SwitchShop from '../shop/switch-shop';

const iconStyle = {
    fontSize: 28,
}

export default () => {
  return (
    <div>
        <SwitchShop />
        
        {/* 快捷操作 - iOS 风格图标组 */}
        <div className="mt-3 mb-4">
            <AppIconGroup 
                items={[
                    can('proxy', 'goods') && {
                        id: 1,
                        href: '/goods/proxy',
                        title: '代理商品',
                        icon: <TransactionOutlined />,
                        color: 'from-blue-500 to-blue-600'
                    },
                    {
                        id: 2,
                        href: '/shop/level-partner',
                        title: '代理等级管理',
                        icon: <OrderedListOutlined />,
                        color: 'from-green-500 to-green-600'
                    },
                    {
                        id: 3,
                        href: '/shop/level-user',
                        title: '分销等级管理',
                        icon: <OrderedListOutlined />,
                        color: 'from-purple-500 to-purple-600'
                    }
                ].filter(Boolean)}
                cols="3-3-3-3-3"
            />
        </div>
        
        <h2 className="admin-page-title">我的销售网</h2>
        <ProxyList />
    </div>
  )
}